module.exports = __webpack_public_path__ + "img/battery.d7378807.png";